import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Row, Col, CardTitle,FormText,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import ReactInputMask from 'react-input-mask';

const modeloDatos = {
    articuloID: 0,
    descripcion:"",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}

const Version = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [imageSrc, setImageSrc] = useState("");
    const [file, setFile] = useState(null);
    const [verModalFoto, setverModalFoto] = useState(false);


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "Transporte/listaArticulo" );
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
       
           
           
        }
    }


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("image", file);

        const response = await fetch(Api + "Administracion/UploadImage/" + tabla.empresaID, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        fetchImage1();

        setFile(null)
        console.log("Respuesta:", data);
    };
    const fetchImage1 = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + tabla.empresaID);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };


    useEffect(() => {
        const fetchImage = async () => {
            const response = await fetch(Api + "Administracion/MostraFoto/" + tabla.empresaID);
            const blob = await response.blob();
            setImageSrc(URL.createObjectURL(blob));
        };

        fetchImage();
    }, [tabla.empresaID]);


    useEffect(() => {
        obtenerDatos();
    })


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.articuloID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarArticulos", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditarArticulos", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            Swal.fire(
                'Guardado!',
                '' + tabla.nombre,
                'success'
            )
            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
         
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverModalFoto(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.articuloID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        },
       
      
        {
           
            //cell: row => {
            //    let clase;
            //    clase = row.activa ? "badge badge-info p-2" : "badge badge-danger p-2"
            //    return (
            //        <span className={clase}>{row.activa ? "Activo" : "No Activo"}</span>
            //    )
            //}
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                  

                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => (setverModalFoto(true), tabla.empresaID = row.empresaID)} title="Cambiar Foto"
                    >
                        <i className="fas fa-images"></i>
                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Articulo
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Articulo</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className=" modal-header1">
                    Mantenimiento de Cliente
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                    <FormGroup>
                      
                                <Label>Nombre </Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                    </FormGroup></Col>
                   
                  
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={verModalFoto} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Subir Foto de Articulo </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <CardBody>
                            <CardTitle tag="h5">Imagen de Articulo / servicio</CardTitle>
                            <FormGroup>
                                <Label for="fileInput">Seleccionar Imagen</Label>
                                <Input type="file" id="fileInput" onChange={handleFileChange} />
                                <FormText color="muted">Formato recomendado: JPG o PNG. Tamaño máximo: 2MB.</FormText>

                                {(file != null) && <Button color="primary" size="sm" onClick={handleUpload}>Guardar</Button>}
                                {imageSrc && (
                                    <div className="mt-3">
                                        <img src={imageSrc} alt="Imagen cargada" width="200" className="rounded shadow-sm" />
                                    </div>
                                )}</FormGroup>
                        </CardBody>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    )

}
export default Version;